import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseDeleteDiagnosticObjectiveActivityProps {
  diagnosticObjectiveActivityId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useDeleteDiagnosticObjectiveActivity = ({
  diagnosticObjectiveActivityId,
  options,
}: UseDeleteDiagnosticObjectiveActivityProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteDiagnosticObjectiveP'],
    mutationFn: () => {
      return privateAxios.delete(`/maintenance/diagnostic_objective_activities/${diagnosticObjectiveActivityId}`);
    },
    ...options
  });
}
